import { render } from "./CustomerCaseList.vue?vue&type=template&id=3af44653"
import script from "./CustomerCaseList.vue?vue&type=script&lang=js"
export * from "./CustomerCaseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__